import {GraphLayout, MergedFactPanelEntry, SimpleFactPanelEntry} from './interface';

export function isSimpleFactPanelEntry(
    entry: SimpleFactPanelEntry | MergedFactPanelEntry
): entry is SimpleFactPanelEntry {
    return !!(entry as SimpleFactPanelEntry).content;
}

export function getLayoutDiff(oldLayout: GraphLayout, newLayout: GraphLayout) {
    const changedPositionsOld: GraphLayout = {};
    const changedPositionsNew: GraphLayout = {};

    Object.keys(oldLayout).forEach((nodeId) => {
        if (
            JSON.stringify(oldLayout[Number(nodeId)]) !== JSON.stringify(newLayout[Number(nodeId)])
        ) {
            changedPositionsOld[Number(nodeId)] = oldLayout[Number(nodeId)];
            changedPositionsNew[Number(nodeId)] = newLayout[Number(nodeId)];
        }
    });

    return {changedPositionsOld, changedPositionsNew};
}
